/**
 * LOSEFORD 商品ページ — 写真ごとのモデル情報
 *
 * 松本様ご指摘 2026-08-27:
 *   「モデル情報を、選択中の写真のすぐ下（写真の外・左寄せ・1行）に表示。
 *     画像を切り替えると、その画像のモデル情報に連動して切り替わる。
 *     画像（カット）ごとに個別に入力できる形に。入力があれば表示、空なら非表示」
 *
 * 値は商品メタフィールド custom.model_note（複数行テキスト）。
 * 新しい欄は増やしていないので、今お使いの欄に行を足すだけで済む。
 *
 *   1行だけ                    … どの写真でも同じものを出す（今までどおり）
 *   複数行                      … 上から順に 1枚目・2枚目… に対応。空行はその写真だけ非表示
 *   「3: H155cm / 着用17cm」    … 何枚目かを明示したいとき（枚数を数えなくてよい）
 *   「3-8: 着用約45cm」      … 3枚目から8枚目まで同じ表記を出したいとき
 *
 * 「N:」の書き方を混ぜても構わない。番号付きの行は位置の数に入れないので、
 * 番号なしの行だけが上から順に割り当てられる。
 */
(function () {
  var ROOT = '[data-lf-model-caption]';
  // 「何枚目か」の指定として受け付ける上限。商品写真がこれを超えることは無い。
  var MAX_INDEX = 50;

  /** メタフィールドの本文を「写真の並び順」の配列に変える */
  function parseNotes(raw) {
    var lines = String(raw || '').split(/\r?\n/);
    var keyed = {};        // 「N:」で位置を指定した行
    var ordered = [];      // 番号なしの行（空行も1枚分として数える）
    var plainCount = 0;

    lines.forEach(function (line) {
      var text = line.replace(/\s+$/, '');
      // 判定用に全角数字だけ半角へ寄せる。1文字1文字の置換なので位置はずれない。
      // 本文の全角数字を壊さないよう、値は元の行から取り出す。
      var norm = text.replace(/[０-９]/g, function (c) {
        return String.fromCharCode(c.charCodeAt(0) - 0xfee0);
      });
      // 「3:」の単独指定と「3-8:」の範囲指定の両方を受ける。
      // 区切りは日本語入力で出る long vowel / 全角ハイフン / マイナス / 各種ダッシュも許す。
      var m = norm.match(/^\s*(\d+)\s*(?:[-\u2010\u2012\u2013\u2014\u2015\u2212\u301c\u30fc\uff0d\uff5e~]\s*(\d+))?\s*[:：]\s*(.*)$/);
      // 写真の枚数として現実的な範囲でだけ「何枚目か」の指定とみなす。
      // これを入れないと「155-160: 着用M」のような本文が指定と誤解され、行ごと消える。
      // 既知の制限: 「10-18:00 営業」のような時刻範囲は枚数指定と同じ形になる。
      // モデル情報欄では起こらない入力のため、特別扱いは入れていない。
      if (m && Number(m[1]) >= 1 && Number(m[1]) <= MAX_INDEX && (!m[2] || Number(m[2]) <= MAX_INDEX)) {
        var from = Number(m[1]);
        var to = m[2] ? Number(m[2]) : from;
        if (to < from) { var swap = from; from = to; to = swap; }
        var value = text.slice(text.length - m[3].length).trim();
        for (var i = from; i <= to; i += 1) keyed[i - 1] = value;
        return;
      }
      ordered.push(text.trim());
      if (text.trim()) plainCount += 1;
    });

    // 番号なしがちょうど1行だけなら、商品全体の表記とみなす（今までの1行運用）
    var single = null;
    if (plainCount === 1 && Object.keys(keyed).length === 0) {
      single = ordered.filter(function (t) { return t; })[0];
    }
    return { keyed: keyed, ordered: ordered, single: single };
  }

  function textFor(notes, index) {
    if (notes.single !== null && notes.single !== undefined) return notes.single;
    if (Object.prototype.hasOwnProperty.call(notes.keyed, index)) return notes.keyed[index];
    return notes.ordered[index] || '';
  }

  function setup(root) {
    var holder = root.querySelector('[data-lf-model-notes]');
    var valueEl = root.querySelector('[data-lf-model-caption-value]');
    if (!holder || !valueEl) return;

    var raw = '';
    try { raw = JSON.parse(holder.textContent); } catch (e) { raw = holder.textContent || ''; }
    // メタフィールドを .value なしで渡された場合など、文字列以外が来ても表示を壊さない
    if (raw && typeof raw === 'object') {
      raw = Array.isArray(raw) ? raw.join('\n') : (raw.value || '');
    }
    var notes = parseNotes(raw);

    var photos = root.closest('.product__photos') || document;
    var thumbs = photos.querySelector('[data-product-thumbs]');

    function apply(index) {
      var text = textFor(notes, index);
      valueEl.textContent = text;
      // 入力がない写真では行ごと出さない
      root.hidden = !text;
    }

    /** いま選ばれている写真が何枚目か */
    function currentIndex() {
      if (thumbs) {
        var active = thumbs.querySelector('.product__thumb.is-active, .product__thumb-item.is-active .product__thumb');
        if (active) {
          var i = Number(active.getAttribute('data-index'));
          if (!isNaN(i)) return i;
        }
      }
      // サムネイルが無い（写真1枚）／まだ印が付いていないときは先頭
      var slider = photos.querySelector('[data-product-photos]');
      if (slider) {
        var sel = slider.querySelector('.is-selected');
        if (sel) {
          var all = [].slice.call(sel.parentNode.children);
          var pos = all.indexOf(sel);
          if (pos >= 0) return pos;
        }
      }
      return 0;
    }

    apply(currentIndex());

    // サムネイルの「選択中」の印が付け替わったら追従する。
    // スワイプでもテーマがサムネイルを同期させるので、これだけで両方に効く。
    if (thumbs) {
      new MutationObserver(function () { apply(currentIndex()); })
        .observe(thumbs, { attributes: true, attributeFilter: ['class'], subtree: true });
    }

    // Flickity の切り替え（スワイプ・矢印・ドット）にも直接つないでおく。
    var slider = photos.querySelector('[data-product-photos]');
    if (slider && window.jQuery) {
      try {
        window.jQuery(slider).on('select.flickity', function () {
          setTimeout(function () { apply(currentIndex()); }, 0);
        });
      } catch (e) { /* テーマ側の実装が変わっても表示は壊さない */ }
    }

    // バリアント切り替えで写真が飛ぶ場合にも合わせる
    document.addEventListener('variantImageChange', function () {
      setTimeout(function () { apply(currentIndex()); }, 60);
    });
  }

  function start() {
    var roots = document.querySelectorAll(ROOT);
    Array.prototype.forEach.call(roots, setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // テーマエディタでセクションを描き直したときにも効かせる
  document.addEventListener('shopify:section:load', start);
})();
